import React from 'react';
import { Flex, Text, Link, Button, Image } from '@chakra-ui/react';
import shareIcon from '../../Images/Icons/share.svg';
import notShareIcon from '../../Images/Icons/notshare.svg';
import sendmailImg from '../../Images/Icons/sendmail.svg';

const ShareLinkControls = ({ 
  shareInfo, 
  onUpdatePassword, 
  onCopyLink, 
  onShowSendEmail, 
  onCancelShare, 
  onEnableSharing 
}) => {
  if (shareInfo.shared) {
    return (
      <Flex align="center" position="absolute" right="2vw">
        <Text>{shareInfo.shareDate} 分享生效</Text>
        <Link 
          mx="8px" 
          color="#005AA3" 
          onClick={() => {
            onUpdatePassword();
            onCopyLink();
          }}
        >
          複製連結
        </Link>
        <Button
          bg="#008E96"
          color="white"
          leftIcon={<Image src={sendmailImg} />}
          onClick={() => {
            onUpdatePassword();
            onShowSendEmail();
          }}
          size="sm"
          variant="solid"
          rightIcon={null}
          isLoading={false}
          w="93px"
          h="32px"
          px="12px"
          py="7px"
          ml="8px"
          borderRadius="4px"
          _hover={{
            bg: '#007685',
            boxShadow: 'md',
          }}
          fontSize="12px"
        >
          寄送證書
        </Button>
        <Button
          variant="normal"
          fontWeight={'normal'}
          leftIcon={<Image src={notShareIcon} />}
          onClick={onCancelShare}
          fontSize="20px"
        >
          取消這次分享
        </Button>
      </Flex>
    );
  } 
  
  return (
    <Button
      variant="normal"
      fontWeight={400}
      position="absolute"
      right="2vw"
      fontSize="20px"
      leftIcon={<Image src={shareIcon} />}
      onClick={onEnableSharing}
    >
      啟用單次分享
    </Button>
  );
};

export default ShareLinkControls;
